// extracted by mini-css-extract-plugin
export default {"wrapper":"Step0_wrapper__i8Qjt","list":"Step0_list__vLC99","box":"Step0_box__oKGCQ","image":"Step0_image__wUX2-","link":"Step0_link__m8Q7N","button":"Step0_button__OchWT"};